/**
 * Minimal module lifecycle for the theme's JS: app.use(SomeModule) creates the module once the DOM
 * is ready, awaits its boot() and then calls ready().
 */
export class Module {
  constructor (app) {
    this.app = app
  }

  boot (app) {}

  ready (app) {}
}

export class Application {
  constructor (options = {}) {
    this.options = options
  }

  use (ModuleClass) {
    const start = () => {
      const module = new ModuleClass(this)

      Promise.resolve()
        .then(() => module.boot(this))
        .then(result => module.ready(this, result))
        .catch(reason => {
          if (reason instanceof Error) {
            console.error(reason)
          }
        })
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', start)
    } else {
      start()
    }

    return this
  }
}
